export default "__VITE_PUBLIC_ASSET__7f54b0cc__"